module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chess-info"
  }, [_c('div', {
    staticClass: "chess-info-board"
  }, [_c('canvas', {
    attrs: {
      "id": 'sgf_' + _vm.chessSgf.chess_sgf.id,
      "width": "220",
      "height": "220"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chess-info-info"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.parseSgf.ev || '空'))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "players"
  }, [_c('div', {
    staticClass: "player left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/黑子.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.parseSgf.pb))])]), _vm._v(" "), _c('div', {
    staticClass: "player right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/白子.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.parseSgf.pw))])])]), _vm._v(" "), _c('div', {
    staticClass: "star"
  }, [_vm._l((_vm.star), function(i) {
    return _c('img', {
      attrs: {
        "src": require("../assets/星2.png")
      }
    })
  }), _vm._v(" "), _vm._l((3 - _vm.star), function(i) {
    return _c('img', {
      attrs: {
        "src": require("../assets/星1.png")
      }
    })
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-718e226c"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/component/ChessInfo.vue
// module id = 212
// module chunks = 2